import React from "react";
import styles from "./collapsed_data_list.module.css";

const ShippingData = ({ order_shipping_name, order_shipping_description }) => {

  return (
    <div className={styles.data_list}>
      <div className={styles.item_container}>
        <p className={styles.name_data}>Способ получения: </p>
        <div className={styles.value_data}>{order_shipping_name}</div>
      </div>
      <div className={styles.item_container}>
        <p className={styles.name_data}>Место получения: </p>
        <div className={styles.value_data}>{order_shipping_description}</div>
      </div>
    </div>
  )
}

export default ShippingData;
